// extracted by mini-css-extract-plugin
export var bubble = "_40-0";
export var container = "_40-3";
export var contrastBorder = "_40-4";
export var greyOut = "_40-2";
export var initialsWrapper = "_40-1";
export var large = "_40-9";
export var medium = "_40-8";
export var mediumSmall = "_40-7";
export var mediumSmallMedium = "_40-c";
export var micro = "_40-5";
export var small = "_40-6";
export var tiny = "_40-b";
export var xTiny = "_40-a";